import { Typography } from 'antd'
import { WrapperProps } from './types'

/**
 * @example
 * No Recipients have been configured to receive an email for {children} Field Design Change
 * No Recipients have been configured to receive an email for {children} of the Field Design Change
 */
const Wrapper: React.FC<WrapperProps> = ({ children, ofThe }) => {
  return (
    <Typography.Text>
      No Recipients have been configured to receive an email for {children}
      {ofThe === false ? '' : ' of the'} Field Design Change
    </Typography.Text>
  )
}

export default Wrapper
